var _rect, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPagerDuty(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 6.22217,
    y: 4.79993,
    width: 35.5556,
    height: 38.4,
    rx: 4.16667,
    fill: "#06AC38"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.315 29.7684H15.8518V36.5147H19.315V29.7684Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.8948 12.4365C27.0358 11.3764 25.7465 11.1997 22.7031 11.1997H15.8518V26.5556H19.315H19.7647H22.6732C25.3867 26.5556 27.4106 26.3789 29.1947 25.11C31.1436 23.7286 32.1481 21.4316 32.1481 18.7813C32.1481 15.9061 30.9038 13.6091 28.8948 12.4365ZM23.4677 23.3431H19.315V14.4926L23.2279 14.4604C26.796 14.4122 28.58 15.7615 28.58 18.8134C28.58 22.0902 26.3762 23.3431 23.4677 23.3431Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPagerDuty);
export default __webpack_public_path__ + "static/media/PagerDuty.c85e6012.svg";
export { ForwardRef as ReactComponent };